// extracted by mini-css-extract-plugin
export default {"btn":"MicrositePublishButton_btn__I+XUn","spinner":"MicrositePublishButton_spinner__m68RB","spin":"MicrositePublishButton_spin__6QG2l"};